/* assets/int-fit-quiz.js
   Moved out of snippets/fake-fit-quiz.liquid on 2026-09-10 to cut the PDP HTML payload.
   It rendered as a 40,712 byte inline <script> block there, of which ~7.7 KB was Liquid
   built data (COPY, FIT_DATA, ICONS, FIT_ORDER and the int_pdp.fit_* strings). That data
   now arrives as JSON in #int-ffq-data, immediately above the <script src> that loads this.
   ⛔ Loaded with a PLAIN <script src>, NOT defer, at the exact position the inline block
   held. window.INT_FIT_STYLE / INT_FIT_UNIT / INT_FIT_SIBS are still set inline earlier in
   the snippet and are read here unchanged.
   REVERT: paste this back between <script> tags at the marker in the snippet and restore
   the Liquid COPY/FIT_DATA loop and the fit_* tags from git or from the marker comment.
   2026-10-05: EasySize removed. The tile no longer teleports #easysize_button; Find My Size
   (assets/int-fms.js) opens from the tile, and ?fitquiz=1 is handled there too. */

(function() {

  function rememberSize(size){
    try {
      var st = window.INT_FIT_STYLE;
      if (st && size) localStorage.setItem('int_fit_size_' + st, String(size).toUpperCase());
    } catch (e) {}
  }

  /* ── INT v2 config: per-style data, descriptors, icons ───────────── */
  /* Copy stays in the locale file so it translates; only the data moved to
     metaobjects. A style with no entry here falls back to its metaobject
     display_name, so a newly created style works before it is translated. */
  /* 2026-09-10 PDP PAYLOAD: COPY, FIT_DATA, ICONS and FIT_ORDER were built by Liquid
     right here. They now arrive as JSON in #int-ffq-data, written by the snippet, and the
     expressions below are the SAME ones Liquid used to emit, so behaviour is unchanged. */
  var D = {};
  try { D = JSON.parse(document.getElementById('int-ffq-data').textContent); } catch (e) { D = {}; }
  var COPY = D.copy || {};
  var FIT_DATA = {};
  var ICONS = {};
  var FIT_ORDER = [];
  (D.styles || []).forEach(function (st) {
    FIT_ORDER.push(st.key);
    FIT_DATA[st.key] = {
      name: (COPY[st.key] || {}).l || st.displayName,
      desc: (COPY[st.key] || {}).d || '',
      sizes: st.sizes
    };
    ICONS[st.key] = st.icon;
  });
  /* ICONS is populated above, from the metaobjects. */
  /* FAMILY and ORDERS are gone: grouping now lives on the metaobject
     (family + position) and only one family reaches the browser. */


  /* One ink per icon. The house illustration set separates the heavy contour
     from the light detail by STROKE WEIGHT, not by colour, so both groups take
     the same colour and only the active/inactive state changes it. */
  var INK_ON = '#2B2B2B', INK_OFF = '#C4C0B8';

  /* Labels come from FIT_DATA[key].name, which is the locale string when
     there is one and the metaobject's display_name when there is not. */
  function labelFor(k) { return (FIT_DATA[k] && FIT_DATA[k].name) || ''; }

  /* "style~url|style~url|" from Liquid -> { style: url } */
  var SIBS = (function () {
    var out = {}, raw = (window.INT_FIT_SIBS || '').split('|');
    for (var i = 0; i < raw.length; i++) {
      if (!raw[i]) continue;
      var bits = raw[i].split('~');
      if (bits.length === 2) out[bits[0]] = bits[1];
    }
    return out;
  })();

  /* INT 2026-09-17: the guard below is GONE because the thing it guarded is gone.
     The strip used to hold <a> cells linking to the sibling styles, so a tap had
     to be told whether it meant "switch style" or "open the quiz". On a phone the
     tile is 205px tall and the strip is the bottom 100 of it, so half the control
     silently navigated to another product and read as "the button does nothing".
     Measured and reproduced 2026-09-17. The strip is now inert; the style switch
     lives under the tile as a labelled row. See buildSwitchRow below. */


  function buildCell(key, active) {
    var ic = buildIcon(key, active);
    if (!ic) { return ''; }
    var cap = '<span class="ffq-cap">' + labelFor(key) + '</span>';
    /* INT 2026-09-17: ALWAYS a span, never an <a>. Nothing inside the tile may
       navigate, so every tap anywhere on it opens the fit quiz. */
    return '<span class="ffq-cell' + (active ? ' is-on' : '') + '">' + ic + cap + '</span>';
  }

  function buildIcon(key, active) {
    var c = ICONS[key];
    if (!c) { return ''; }
    var col = active ? INK_ON : INK_OFF;
    var det = (c.det || []).map(function(d){ return '<path d="' + d + '"/>'; }).join('');
    var dots = (c.dots || []).map(function(p){
      return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="1.7"/>';
    }).join('');
    return '<svg class="ffq-ico' + (active ? ' is-on' : '') + '" viewBox="0 0 120 120"'
      + ' fill="none" stroke="' + col + '" stroke-linecap="round" stroke-linejoin="round"'
      + ' aria-hidden="true" focusable="false">'
      + '<g stroke-width="4"><path d="' + c.body + '"/></g>'
      + (det ? '<g stroke-width="2.1">' + det + '</g>' : '')
      + (dots ? '<g fill="' + col + '" stroke="none">' + dots + '</g>' : '')
      + '</svg>';
  }

  function currentSize(fs) {
    /* The size options are real radio inputs: <input type="radio" value="XS">.
       Read the checked input's VALUE — the label text includes a hidden
       "sold out" string and must not be used. */
    var checked = fs.querySelector('input[type="radio"]:checked');
    var txt = checked && checked.value ? checked.value : '';
    return (txt || '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  /* INT: default unit comes from Liquid - US-market products lead with inches.
     Still no cross-page persistence; the toggle only affects the current PDP. */
  var fitUnit = (window.INT_FIT_UNIT === 'in') ? 'in' : 'cm';

  var SIZE_ORDER = ["XXS","XS","S","M","L","XL","XXL","2XL","3XL","4XL","5XL"];
  var JUMP = {
    len:   D.jump.len,
    chest: D.jump.chest,
    both:  D.jump.both,
    same:  D.jump.same,
    samel: D.jump.samel
  };

  function median(a) {
    if (!a.length) { return 0; }
    var b = a.slice().sort(function (x, y) { return x - y; });
    var m = Math.floor(b.length / 2);
    return b.length % 2 ? b[m] : (b[m - 1] + b[m]) / 2;
  }

  /* Is the step up INTO this size out of character for the garment?
     Thresholds are deliberately dual - a relative test (1.5x / 1.4x the usual
     step) and an absolute one (2cm length, 1.5cm half-chest) - so a style that
     grades in 1cm increments does not fire on every 2cm step, and a style with
     a tiny typical step does not fire on a rounding artefact. */
  function jumpNote(style, size, unit) {
    var s = FIT_DATA[style];
    if (!s || !s.sizes) { return ''; }
    var ks = SIZE_ORDER.filter(function (k) { return s.sizes[k]; });
    var i = ks.indexOf(size);
    if (i < 1) { return ''; }

    var dl = [], dc = [], j;
    for (j = 0; j < ks.length - 1; j++) {
      dl.push(Math.round((s.sizes[ks[j + 1]][0] - s.sizes[ks[j]][0]) * 10) / 10);
      dc.push(Math.round((s.sizes[ks[j + 1]][1] - s.sizes[ks[j]][1]) * 10) / 10);
    }
    var n = i - 1, prev = ks[i - 1];
    function baseline(arr) { var o = arr.slice(); o.splice(n, 1); return median(o); }
    var bl = baseline(dl), bc = baseline(dc);
    function v(cm) {
      return unit === 'in' ? (Math.round(cm / 2.54 * 10) / 10) + '″' : cm + ' cm';
    }
    function fill(t, map) {
      Object.keys(map).forEach(function (k) { t = t.split('{' + k + '}').join(map[k]); });
      return t;
    }

    if (dl[n] === 0 && dc[n] === 0) { return fill(JUMP.same, { size: size, prev: prev }); }

    var bigL = dl[n] >= bl + 2 && dl[n] >= bl * 1.5;
    var bigC = dc[n] >= bc + 1.5 && dc[n] >= bc * 1.4;

    if (bigL && bigC) {
      return fill(JUMP.both, { size: size, prev: prev,
        dlen: v(dl[n]), dchest: v(dc[n]), around: v(dc[n] * 2) });
    }
    if (bigL) {
      return fill(JUMP.len, { size: size, prev: prev, delta: v(dl[n]), typical: v(bl) });
    }
    if (bigC) {
      return fill(JUMP.chest, { size: size, prev: prev,
        delta: v(dc[n]), around: v(dc[n] * 2), typical: v(bc) });
    }
    if (dl[n] === 0 && bl > 0) { return fill(JUMP.samel, { size: size, prev: prev }); }
    return '';
  }

  function fmtMeas(style, size, unit) {
    var s = FIT_DATA[style];
    var key = (size && s.sizes[size]) ? size : (s.sizes['M'] ? 'M' : Object.keys(s.sizes)[0]);
    var d = s.sizes[key];
    var inch = unit === 'in';
    function v(cm) { return inch ? (Math.round(cm / 2.54 * 10) / 10) + '″' : cm + ' cm'; }
    return D.measLine.replace('{size}', key).replace('{length}', v(d[0])).replace('{chest}', v(d[1]));
  }

  function richMarkup(style) {
    /* The product being viewed always comes first and is the highlighted one.
       A style with no family shows only itself rather than borrowing the tee
       row, so a new product added before its ORDERS entry degrades quietly. */
    var sibs = FIT_ORDER.length ? FIT_ORDER : [style];
    var order = [style].concat(sibs.filter(function(k){ return k !== style; }));
    var cells = order.map(function(k){ return buildCell(k, k === style); }).join('');
    return ''
      + '<span class="ffq-head">'
      + '<span class="ffq-txt">'
      +   '<span class="ffq-ai"><svg width="11" height="11" viewBox="0 0 12 12" fill="#0e9f8e"><path d="M6 0 L7.1 4.9 L12 6 L7.1 7.1 L6 12 L4.9 7.1 L0 6 L4.9 4.9 Z"/></svg>AI</span>'
      +   '<span class="ffq-l1">' + D.findBest + '</span>'
      +   '<span class="ffq-l2">' + D.noMeasuring + '</span>'
      +   '<span class="ffq-l3">' + D.tuned + '</span>'
      + '</span>'
      + '<span class="ffq-chev">›</span>'
      + '</span>'
      + '<span class="ffq-strip">' + cells + '</span>';
  }

  /* INT 2026-09-17: the style switch, moved OUT of the tile and under it.
     Same SIBS map the strip used to link from, rendered as plain underlined
     links with a label, so a shopper can see it is a link before tapping it.
     It is appended to #fake-fit-quiz-note, which travels with the tile every
     time int-pdp-mobile.js or int-size-select.js relocates the pair. The note
     is not the quiz trigger, so these links need no stopPropagation. */
  function buildSwitchRow(style) {
    var keys = (FIT_ORDER.length ? FIT_ORDER : []).filter(function (k) {
      return k !== style && SIBS[k] && labelFor(k);
    });
    if (!keys.length) { return ''; }
    var links = keys.map(function (k) {
      return '<a class="ffq-sw" href="' + SIBS[k] + '">' + labelFor(k) + '</a>';
    }).join('<span class="ffq-sw-sep" aria-hidden="true">\u00b7</span>');
    var lbl = D.alsoExplore ? '<span class="ffq-sw-lbl">' + D.alsoExplore + '</span>' : '';
    return '<span class="ffq-switch">' + lbl + links + '</span>';
  }

  function findSizeFieldset() {
    var fieldsets = document.querySelectorAll('.radio__fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && legend.textContent.trim().toLowerCase().indexOf('size') !== -1) {
        return fieldsets[i];
      }
    }
    return null;
  }

  function inject(fieldset) {
    if (document.getElementById('fake-fit-quiz')) return;
    /* INT 2026-09-18: WHERE THE TILE IS APPENDED AND WHAT IT READS THE SIZES FROM ARE TWO
       DIFFERENT JOBS, AND THEY USED TO SHARE ONE ARGUMENT.
       `fieldset` stays the Size fieldset, because currentSize(), repaintMeas() and applyReco()
       all read `fieldset.querySelectorAll('input[type="radio"]')` and the change listener is
       scoped with `fieldset.contains(e.target)`. Retargeting the whole argument would have
       silently killed the measurement line, the jump note and the quiz result preselect.
       Only the APPEND TARGET moves. `.int-mob-fit` is rendered in sections/product.liquid
       immediately before the fake-fit-quiz snippet, so the tile is built in its final home and
       nothing has to move it afterwards. Measured 2026-09-17: the tile was appended to the Size
       fieldset during parse and carried into `.int-mob-fit` about 280 ms later, worth an 0.03009
       layout shift entry on 18 of 19 loads at 1440.
       The `|| fieldset` fallback is today's behaviour, kept for any template that renders this
       snippet without the holder. The Size fieldset gate below is untouched, so a product with no
       size options still gets no tile. */
    var home = document.querySelector('.int-mob-fit') || fieldset;
    var style = window.INT_FIT_STYLE;
    var rich = !!(style && FIT_DATA[style]);

    var btn = document.createElement('div');
    btn.id = 'fake-fit-quiz';
    if (rich) {
      btn.className = 'ffq-rich';
      btn.innerHTML = richMarkup(style);
    } else {
      btn.textContent = D.findPlain;
    }
    home.appendChild(btn);

    if (rich) {
      var note = document.createElement('div');
      note.id = 'fake-fit-quiz-note';
      note.innerHTML = '<span class="ffq-nm">' + D.thisStyle + ' · ' + FIT_DATA[style].name + '</span>'
        + '<span class="ffq-desc">' + FIT_DATA[style].desc + '</span>'
        + '<div class="ffq-measrow">'
        +   '<span class="ffq-meas">' + fmtMeas(style, currentSize(fieldset), fitUnit) + '</span>'
        +   '<span class="ffq-unit">' + (fitUnit === 'in'
        ? '<button type="button" data-u="in">in</button><button type="button" data-u="cm">cm</button>'
        : '<button type="button" data-u="cm">cm</button><button type="button" data-u="in">in</button>') + '</span>'
        + '</div>'
        + '<span class="ffq-jump"></span>'
        + buildSwitchRow(style);
      home.appendChild(note);

      var measEl = note.querySelector('.ffq-meas');
      var unitBtns = note.querySelectorAll('.ffq-unit button');
      function paintUnit() {
        for (var i = 0; i < unitBtns.length; i++) {
          unitBtns[i].classList.toggle('on', unitBtns[i].getAttribute('data-u') === fitUnit);
        }
      }
      var jumpEl = note.querySelector('.ffq-jump');
      function repaintMeas() {
        var sz = currentSize(fieldset);
        if (measEl) { measEl.textContent = fmtMeas(style, sz, fitUnit); }
        if (jumpEl) {
          var j = jumpNote(style, sz, fitUnit);
          jumpEl.textContent = j;
          jumpEl.style.display = j ? '' : 'none';
        }
      }
      paintUnit();
      for (var i = 0; i < unitBtns.length; i++) {
        unitBtns[i].addEventListener('click', function(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          fitUnit = this.getAttribute('data-u');
          paintUnit();
          repaintMeas();
        });
      }
      document.addEventListener('change', function(e) {
        if (e.target && e.target.matches && e.target.matches('input[type="radio"]') && fieldset.contains(e.target)) {
          repaintMeas();
          var sz = currentSize(fieldset);
          if (sz) rememberSize(sz);
        }
      }, true);
      /* Belt-and-suspenders: also repaint on the theme's variant events */
      ['variant:change', 'theme:variant:change'].forEach(function(ev) {
        document.addEventListener(ev, function() { setTimeout(repaintMeas, 20); }, true);
      });
    }
  }

  /* Inject fake button */
  var fs = findSizeFieldset();
  if (fs) {
    inject(fs);
  } else {
    var mount = setInterval(function() {
      var fs2 = findSizeFieldset();
      if (fs2) { inject(fs2); clearInterval(mount); }
    }, 30);
    setTimeout(function() { clearInterval(mount); }, 5000);
  }

  /* One-size check */
  document.addEventListener('DOMContentLoaded', function() {
    var sw = document.querySelector('[data-select-label="Size"]');
    var sb = sw ? sw.querySelectorAll('.radio__button') : [];
    if (sb.length === 1 && sb[0].textContent.toLowerCase().includes('one size')) {
      var fq = document.getElementById('fake-fit-quiz');
      if (fq) fq.style.setProperty('display', 'none', 'important');
      var nt = document.getElementById('fake-fit-quiz-note');
      if (nt) nt.style.setProperty('display', 'none', 'important');
    }
  });

  /* Fix Flickity height lock gap on mobile after image load */
  function fixFlickityHeight() {
    var gallery = document.querySelector('[data-product-slideshow]');
    if (!gallery) return;
    var flkty = window.Flickity && Flickity.data(gallery);
    if (flkty) flkty.resize();
  }
  window.addEventListener('load', function() {
    setTimeout(fixFlickityHeight, 100);
    setTimeout(fixFlickityHeight, 500);
    setTimeout(fixFlickityHeight, 1200);
    [300, 800, 1500].forEach(function(d) {
      setTimeout(function() {
        var ss = document.querySelector('[data-product-slideshow]');
        if (!ss) return;
        ss.querySelectorAll('[data-media-slide]').forEach(function(slide) {
          if (parseInt(slide.style.height) >= 590) slide.style.removeProperty('height');
        });
      }, d);
    });
  });

  /* ── VP HEIGHT CORRECTION ───────────────────────────────── */
  (function() {
    function correctVPHeight() {
      if (window.innerWidth >= 768) return;
      var ss = document.querySelector('[data-product-slideshow]');
      var vp = ss && ss.querySelector('.flickity-viewport');
      if (!ss || !vp) return;
      var sel = ss.querySelector('[data-media-slide].is-selected');
      if (!sel) return;

      function applyHeight() {
        var h = sel.offsetHeight;
        if (h > 20) {
          vp.style.height = h + 'px';
          ss.style.removeProperty('height');
          ss.style.removeProperty('min-height');
        }
      }

      var img = sel.querySelector('img');
      if (img && !img.complete) {
        img.addEventListener('load', applyHeight, { once: true });
        img.addEventListener('error', applyHeight, { once: true });
        setTimeout(applyHeight, 80);
      } else {
        applyHeight();
      }
      [200, 500, 1000].forEach(function(d) { setTimeout(applyHeight, d); });
    }

    document.addEventListener('int:gallery:settled', correctVPHeight);
  })();

  /* ── VIA 600px HEIGHT INTERCEPT ─────────────────────────── */
  (function() {
    var _intVIAObs = null;

    function _fixVPHeight(ss) {
      var vp = ss.querySelector('.flickity-viewport');
      if (!vp) return;
      if (parseInt(vp.style.height) >= 590) {
        var sel = ss.querySelector('[data-media-slide].is-selected');
        var sentinel = window.__intVIASentinel;
        if (sel && sentinel && String(sel.dataset.mediaId) === String(sentinel)) {
          sel = ss.querySelector('[data-media-slide]:not([data-media-id="' + sentinel + '"])');
        }
        var h = sel ? sel.offsetHeight : 0;
        if (h > 20) { vp.style.height = h + 'px'; }
        else         { vp.style.removeProperty('height'); }
      }
    }

  function armVIAHeightIntercept() {
    var ss = document.querySelector('[data-product-slideshow]');
    if (!ss) return;
    if (_intVIAObs) { _intVIAObs.disconnect(); _intVIAObs = null; }

    _intVIAObs = new MutationObserver(function(mutations) {
      if (parseInt(ss.style.height) >= 590)    ss.style.removeProperty('height');
      if (parseInt(ss.style.minHeight) >= 590) ss.style.removeProperty('min-height');

      _fixVPHeight(ss);

      mutations.forEach(function(mut) {
        if (mut.type !== 'childList') return;
        mut.addedNodes.forEach(function(node) {
          if (!node || node.nodeType !== 1) return;
          var newVP = (node.classList && node.classList.contains('flickity-viewport'))
            ? node
            : (node.querySelector && node.querySelector('.flickity-viewport'));
          if (newVP && !newVP.__intVIAObserved) {
            newVP.__intVIAObserved = true;
            _intVIAObs.observe(newVP, { attributes: true, attributeFilter: ['style'] });
            if (parseInt(newVP.style.height) >= 590) _fixVPHeight(ss);
          }
        });
      });
    });

    _intVIAObs.observe(ss, { attributes: true, attributeFilter: ['style'] });
    _intVIAObs.observe(ss, { childList: true, subtree: true });
    var vp = ss.querySelector('.flickity-viewport');
    if (vp) {
      vp.__intVIAObserved = true;
      _intVIAObs.observe(vp, { attributes: true, attributeFilter: ['style'] });
    }

    if (parseInt(ss.style.height) >= 590)    ss.style.removeProperty('height');
    if (parseInt(ss.style.minHeight) >= 590) ss.style.removeProperty('min-height');
    _fixVPHeight(ss);

    ss.querySelectorAll('[data-media-slide]').forEach(function(slide) {
      if (parseInt(slide.style.height) >= 590) slide.style.removeProperty('height');
    });

    setTimeout(function() {
      if (_intVIAObs) { _intVIAObs.disconnect(); _intVIAObs = null; }
    }, 8000);
  }

    document.addEventListener('variant:change', function() {
      setTimeout(armVIAHeightIntercept, 30);
    });
    document.addEventListener('theme:variant:change', function() {
      setTimeout(armVIAHeightIntercept, 30);
    }, true);
    document.addEventListener('change', function(e) {
      if (e.target && e.target.name && e.target.name.toLowerCase().indexOf('color') !== -1) {
        setTimeout(armVIAHeightIntercept, 30);
      }
    }, true);
    document.addEventListener('click', function(e) {
      if (e.target && e.target.closest && e.target.closest('[data-slideshow-thumbnail], .media__thumb')) {
        setTimeout(armVIAHeightIntercept, 30);
      }
    }, true);
    document.addEventListener('int:gallery:settled', armVIAHeightIntercept);
  })();

  /* Fix VIA resetting gallery after variant change */
  (function() {
    var lastFeaturedMediaId = null;
    var correctionTimer = null;
    var mutationTimer = null;

    function selectCorrectSlide(mediaId) {
      var gallery = document.querySelector('[data-product-slideshow]');
      if (!gallery) return;
      var flkty = (window.Flickity && Flickity.data(gallery)) || gallery._flickity;
      if (!flkty) return;
      var slides = gallery.querySelectorAll('[data-media-id]');
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
          flkty.select(i, false, true);
          var _img = slides[i].querySelector('img');
          var _doResize = function() {
            var _f2 = (window.Flickity && Flickity.data(gallery)) || gallery._flickity;
            if (_f2 && typeof _f2.resize === 'function') _f2.resize();
          };
          if (_img && !_img.complete) {
            _img.addEventListener('load',  _doResize, { once: true });
            _img.addEventListener('error', _doResize, { once: true });
          } else {
            setTimeout(_doResize, 60);
          }
          [200, 500, 1000].forEach(function(d) { setTimeout(_doResize, d); });
          return;
        }
      }
    }

    function armMutationWatcher(mediaId) {
      var gallery = document.querySelector('[data-product-slideshow]');
      if (!gallery) return;

      if (window.__intVIAObs) {
        window.__intVIAObs.disconnect();
      }

      window.__intVIAObs = new MutationObserver(function() {
        clearTimeout(mutationTimer);
        mutationTimer = setTimeout(function() {
          window.__intVIAObs.disconnect();
          selectCorrectSlide(mediaId);
        }, 700);
      });

      window.__intVIAObs.observe(gallery, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });

      clearTimeout(correctionTimer);
      correctionTimer = setTimeout(function() {
        if (window.__intVIAObs) window.__intVIAObs.disconnect();
        selectCorrectSlide(mediaId);
      }, 3500);
    }

    document.addEventListener('variant:change', function(e) {
      if (!e.detail || !e.detail.variant) return;
      var v = e.detail.variant;
      if (v.featured_media && v.featured_media.id) {
        lastFeaturedMediaId = v.featured_media.id;
      }
      if (lastFeaturedMediaId) {
        armMutationWatcher(lastFeaturedMediaId);
      }
    });
  })();

})();
